(function () {
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const amount = (Number(cents) / 100).toFixed(2);
    const amountNoDecimals = String(Math.round(Number(cents) / 100));
    const amountWithComma = amount.replace('.', ',');
    const moneyFormat = format || (window.theme && window.theme.moneyFormat) || '{{amount}}';

    return moneyFormat
      .replace('{{amount}}', amount)
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount_with_comma_separator}}', amountWithComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals);
  }

  function initPurchaseHighlights() {
    const highlights = document.querySelector('[data-purchase-highlights]');
    if (!highlights) return;

    const items = Array.from(highlights.querySelectorAll('[data-purchase-item]'));
    if (!items.length) return;
    const card = highlights.querySelector('[data-purchase-card]');
    const closeButton = highlights.querySelector('[data-purchase-close]');
    const nameElement = highlights.querySelector('[data-purchase-name]');
    const cityElement = highlights.querySelector('[data-purchase-city]');
    const productElement = highlights.querySelector('[data-purchase-product]');
    const timeElement = highlights.querySelector('[data-purchase-time]');
    const minimumInterval = Math.max(Number(highlights.dataset.purchaseInterval) || 15000, 15000);
    const maximumInterval = Math.max(Number(highlights.dataset.purchaseMaxInterval) || 30000, minimumInterval);
    const duration = Math.max(Number(highlights.dataset.purchaseDuration) || 5000, 5000);
    let lastItemIndex = -1;
    let hideTimer;

    function getRandomInterval() {
      return Math.floor(Math.random() * (maximumInterval - minimumInterval + 1)) + minimumInterval;
    }

    function hide() {
      window.clearTimeout(hideTimer);
      highlights.hidden = true;
      card.classList.remove('is-visible');
    }

    function showNext() {
      let itemIndex = Math.floor(Math.random() * items.length);
      if (items.length > 1) {
        while (itemIndex === lastItemIndex) {
          itemIndex = Math.floor(Math.random() * items.length);
        }
      }
      lastItemIndex = itemIndex;
      const item = items[itemIndex];
      nameElement.textContent = item.dataset.purchaseName || 'Cliente';
      cityElement.textContent = item.dataset.purchaseCity || '';
      productElement.textContent = item.dataset.product || '';
      timeElement.textContent = item.dataset.purchaseTime || 'recentemente';
      highlights.hidden = false;
      window.requestAnimationFrame(() => card.classList.add('is-visible'));
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(hide, duration);
      window.setTimeout(showNext, getRandomInterval());
    }

    closeButton.addEventListener('click', hide);
    window.setTimeout(showNext, getRandomInterval());
  }

  function initAnnouncementBars() {
    document.querySelectorAll('[data-announcement-bar]').forEach((bar) => {
      if (bar.dataset.announcementInitialized === 'true') return;

      const messages = Array.from(bar.querySelectorAll('[data-announcement-message]'));
      if (messages.length < 2) return;

      bar.dataset.announcementInitialized = 'true';
      const interval = Math.max(Number(bar.dataset.announcementInterval) || 5000, 3000);
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let currentIndex = 0;

      if (reduceMotion) return;

      window.setInterval(() => {
        messages[currentIndex].classList.remove('is-active');
        messages[currentIndex].setAttribute('aria-hidden', 'true');
        currentIndex = (currentIndex + 1) % messages.length;
        messages[currentIndex].classList.add('is-active');
        messages[currentIndex].setAttribute('aria-hidden', 'false');
      }, interval);
    });
  }

  function initPromotionalModals() {
    const modalRoot = document.querySelector('[data-promotional-modals]');
    if (!modalRoot || modalRoot.dataset.initialized === 'true') return;

    const modals = Array.from(modalRoot.querySelectorAll('[data-promotional-modal]'));
    if (!modals.length) return;

    modalRoot.dataset.initialized = 'true';
    let activeModal = null;
    let lastFocusedElement = null;
    let exitIntentTriggered = false;

    function storageKey(modal) {
      return `limiar-modal-${modal.dataset.modalId}`;
    }

    function wasDismissed(modal) {
      const frequency = modal.dataset.modalFrequency;
      if (frequency === 'every_visit') return false;

      try {
        const storage = frequency === 'once' ? window.localStorage : window.sessionStorage;
        return storage.getItem(storageKey(modal)) === '1';
      } catch (error) {
        return false;
      }
    }

    function isAudienceEligible(modal) {
      const audience = modal.dataset.modalAudience || 'non_buyers';
      const hasOrders = modal.dataset.customerHasOrders === 'true';

      if (audience === 'non_buyers') return !hasOrders;
      if (audience === 'buyers') return hasOrders;
      return true;
    }

    function markDismissed(modal) {
      const frequency = modal.dataset.modalFrequency;
      if (frequency === 'every_visit') return;

      try {
        const storage = frequency === 'once' ? window.localStorage : window.sessionStorage;
        storage.setItem(storageKey(modal), '1');
      } catch (error) {
        // Ignore storage errors and keep the modal usable.
      }
    }

    function openModal(modal, force = false) {
      if (activeModal || (!force && wasDismissed(modal)) || !isAudienceEligible(modal)) return false;

      activeModal = modal;
      lastFocusedElement = document.activeElement;
      // Conta a exibição como a vez da sessão, mesmo se o visitante navegar sem fechar.
      markDismissed(modal);
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('has-promotional-modal');
      const closeButton = modal.querySelector('[data-modal-close]');
      if (closeButton) closeButton.focus();
      return true;
    }

    function closeModal(markAsDismissed = true) {
      if (!activeModal) return;

      const modal = activeModal;
      if (markAsDismissed) markDismissed(modal);
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      activeModal = null;
      document.body.classList.remove('has-promotional-modal');
      if (lastFocusedElement && typeof lastFocusedElement.focus === 'function') {
        lastFocusedElement.focus({ preventScroll: true });
      }
    }

    function firstAvailableModal(trigger) {
      return modals.find((modal) => modal.dataset.modalTrigger === trigger && !wasDismissed(modal) && isAudienceEligible(modal));
    }

    function isFirstSiteVisit() {
      try {
        return window.localStorage.getItem('limiar-site-visited') !== '1';
      } catch (error) {
        return false;
      }
    }

    function isMobileViewport() {
      return window.matchMedia('(max-width: 749px)').matches;
    }

    modals.forEach((modal) => {
      modal.querySelectorAll('[data-modal-close]').forEach((closeButton) => {
        closeButton.addEventListener('click', () => closeModal());
      });

      modal.querySelectorAll('[data-modal-copy]').forEach((copyButton) => {
        copyButton.addEventListener('click', async (event) => {
          event.preventDefault();
          event.stopPropagation();
          const value = copyButton.dataset.copyValue || '';
          if (!value) return;

          try {
            if (navigator.clipboard && window.isSecureContext) {
              await navigator.clipboard.writeText(value);
            } else {
              const temporaryInput = document.createElement('input');
              temporaryInput.value = value;
              temporaryInput.setAttribute('readonly', '');
              temporaryInput.style.position = 'fixed';
              temporaryInput.style.opacity = '0';
              document.body.appendChild(temporaryInput);
              temporaryInput.focus();
              temporaryInput.select();
              temporaryInput.setSelectionRange(0, temporaryInput.value.length);
              const copied = document.execCommand('copy');
              temporaryInput.remove();
              if (!copied) throw new Error('Copy command failed');
            }

            const label = copyButton.querySelector('[data-copy-label]');
            const status = modal.querySelector('[data-copy-status]');
            if (label) label.textContent = 'Copiado';
            if (status) status.textContent = 'Conteúdo copiado.';
          } catch (error) {
            const status = modal.querySelector('[data-copy-status]');
            if (status) status.textContent = 'Não foi possível copiar automaticamente.';
          }
        });
      });

      if (modal.dataset.modalTrigger === 'delay') {
        window.setTimeout(() => openModal(modal), Math.max(Number(modal.dataset.modalDelay) || 8000, 1000));
      }

      if (modal.dataset.modalTrigger === 'first_visit') {
        if (isFirstSiteVisit() && !wasDismissed(modal)) window.setTimeout(() => openModal(modal), 1000);
      }

      if (modal.dataset.modalTrigger === 'first_visit_delay') {
        if (isFirstSiteVisit() && !wasDismissed(modal)) {
          window.setTimeout(() => openModal(modal), Math.max(Number(modal.dataset.modalDelay) || 8000, 1000));
        }
      }

    });

    // Depois do envio do e-mail a página recarrega: reabre o modal com o cupom (ou o erro).
    const capturedModal = modals.find((modal) => modal.querySelector('[data-modal-capture-result]'));
    if (capturedModal) {
      exitIntentTriggered = true;
      openModal(capturedModal, true);
    }

    // Mobile não tem mouseout: tratamos como intenção de saída uma rolagem rápida
    // de volta ao topo depois que o visitante já percorreu metade da página.
    if (modals.some((modal) => modal.dataset.modalTrigger === 'exit_intent')) {
      let reachedHalfPage = false;
      let lastScrollY = window.scrollY;
      let lastScrollTime = Date.now();

      window.addEventListener('scroll', () => {
        if (!isMobileViewport() || exitIntentTriggered) return;

        const now = Date.now();
        const currentY = window.scrollY;
        const scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable > 0 && currentY / scrollable >= 0.5) reachedHalfPage = true;

        const upwardDistance = lastScrollY - currentY;
        const elapsed = now - lastScrollTime;
        if (elapsed > 400) {
          lastScrollY = currentY;
          lastScrollTime = now;
        }

        if (!reachedHalfPage || upwardDistance < window.innerHeight * 0.4 || elapsed > 400) return;
        if (document.body.classList.contains('has-open-drawer')) return;

        const modal = firstAvailableModal('exit_intent');
        if (modal && openModal(modal)) exitIntentTriggered = true;
      }, { passive: true });
    }

    try {
      window.localStorage.setItem('limiar-site-visited', '1');
    } catch (error) {
      // Ignore storage errors.
    }

    document.addEventListener('mouseout', (event) => {
      if (isMobileViewport()) return;
      if (exitIntentTriggered || event.clientY > 10 || (event.relatedTarget && document.documentElement.contains(event.relatedTarget))) return;
      exitIntentTriggered = true;
      const modal = firstAvailableModal('exit_intent');
      if (modal) openModal(modal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeModal();
    });

  }

  function initReviewForms() {
    document.querySelectorAll('[data-review-form]').forEach((form) => {
      if (form.dataset.reviewInitialized === 'true') return;
      const section = form.closest('[data-review-endpoint]');
      const endpoint = section?.dataset.reviewEndpoint?.trim();
      if (!endpoint) return;

      form.dataset.reviewInitialized = 'true';
      const status = form.querySelector('[data-review-status]');
      const submit = form.querySelector('button[type="submit"]');
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const values = new FormData(form);
        const originalLabel = submit?.textContent;
        if (submit) { submit.disabled = true; submit.textContent = 'Enviando...'; }
        if (status) { status.hidden = true; status.textContent = ''; }

        try {
          const response = await fetch(endpoint, {
            method: 'POST',
            // text/plain mantém a requisição simples para o Google Apps Script;
            // o conteúdo continua sendo JSON Unicode, preservando emojis e acentos.
            headers: { 'Content-Type': 'text/plain;charset=UTF-8', Accept: 'application/json' },
            body: JSON.stringify({
              name: values.get('contact[nome]'),
              email: values.get('contact[email]'),
              rating: Number(values.get('contact[nota]')),
              comment: values.get('contact[body]'),
              productTitle: values.get('contact[produto]'),
              productUrl: values.get('contact[produto_url]'),
              productGid: values.get('contact[produto_gid]')
            })
          });
          if (!response.ok) throw new Error('review-submit-failed');
          form.reset();
          if (status) { status.hidden = false; status.textContent = 'Recebemos sua avaliação. Ela será publicada após nossa aprovação.'; }
        } catch (error) {
          if (status) { status.hidden = false; status.textContent = 'Não foi possível enviar agora. Tente novamente em instantes.'; }
        } finally {
          if (submit) { submit.disabled = false; submit.textContent = originalLabel || 'Enviar avaliação'; }
        }
      });
    });
  }

  function initReviewLoadMore() {
    document.querySelectorAll('[data-review-load-more]').forEach((button) => {
      if (button.dataset.reviewLoadMoreReady === 'true') return;
      button.dataset.reviewLoadMoreReady = 'true';
      const section = button.closest('.product-comments');
      const grid = section && section.querySelector('[data-review-grid]');
      if (!grid) return;

      button.addEventListener('click', () => {
        const hiddenCards = Array.from(grid.querySelectorAll('[data-review-card][hidden]'));
        hiddenCards.slice(0, 10).forEach((card) => { card.hidden = false; });
        if (!grid.querySelector('[data-review-card][hidden]')) button.hidden = true;
      });
    });
  }

  const drawer = document.querySelector('[data-mobile-drawer]');
  const openButtons = document.querySelectorAll('[data-open-menu]');
  const closeButtons = document.querySelectorAll('[data-close-menu]');
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartOpenButton = document.querySelector('[data-open-cart]');
  const searchDropdown = document.querySelector('[data-search-dropdown]');
  const searchToggle = document.querySelector('[data-search-toggle]');
  const searchPanel = document.getElementById('HeaderSearchPanel');
  const body = document.body;
  const customerDefaultZip = sanitizeZip(body.dataset.customerDefaultZip || '');
  const shippingStateKey = 'limiar-shipping-address';
  const shippingQuoteKey = 'limiar-shipping-quote';
  const cartDrawerStateKey = 'limiar-cart-drawer-open';
  let lastTrigger = null;
  let lastCartTrigger = null;
  let cartShippingZip = customerDefaultZip;
  let cartShippingAddress = null;
  let cartShippingQuote = null;
  let cartShippingAutoRefreshRequested = false;

  initPurchaseHighlights();
  initAnnouncementBars();
  initPromotionalModals();
  initReviewForms();
  initReviewLoadMore();

  document.addEventListener('shopify:section:load', initAnnouncementBars);
  document.addEventListener('shopify:section:load', initPromotionalModals);
  document.addEventListener('shopify:section:load', initReviewForms);
  document.addEventListener('shopify:section:load', initReviewLoadMore);

  function sanitizeZip(value) {
    return String(value || '').replace(/\D/g, '').slice(0, 8);
  }

  function formatZip(value) {
    const zip = sanitizeZip(value);
    if (zip.length !== 8) return zip;
    return `${zip.slice(0, 5)}-${zip.slice(5)}`;
  }

  function readShippingState() {
    try {
      const raw = window.sessionStorage.getItem(shippingStateKey);
      if (!raw) return null;
      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function persistShippingState() {
    try {
      if (!cartShippingZip && !cartShippingAddress) {
        window.sessionStorage.removeItem(shippingStateKey);
        return;
      }

      window.sessionStorage.setItem(
        shippingStateKey,
        JSON.stringify({
          zip: cartShippingZip,
          address: cartShippingAddress,
        }),
      );
    } catch (error) {
      // Ignore storage errors.
    }
  }

  function persistShippingQuote() {
    try {
      if (!cartShippingQuote) {
        window.sessionStorage.removeItem(shippingQuoteKey);
        return;
      }

      window.sessionStorage.setItem(shippingQuoteKey, JSON.stringify(cartShippingQuote));
    } catch (error) {
      // Ignore storage errors.
    }
  }

  function persistCartDrawerState(isOpen) {
    try {
      if (isOpen) {
        window.sessionStorage.setItem(cartDrawerStateKey, '1');
      } else {
        window.sessionStorage.removeItem(cartDrawerStateKey);
      }
    } catch (error) {
      // Ignore storage errors.
    }
  }

  function setShippingState(zip, address) {
    cartShippingZip = sanitizeZip(zip);
    cartShippingAddress = address || null;
    syncShippingZipInputs();
    persistShippingState();
  }

  function getPreferredShippingZip() {
    return cartShippingZip || customerDefaultZip || '';
  }

  function syncShippingZipInputs() {
    const zip = getPreferredShippingZip();
    if (!zip) return;

    document.querySelectorAll('[data-cart-shipping-form] input[name="checkout[shipping_address][zip]"], [data-product-shipping-form] [data-product-shipping-zip]').forEach((input) => {
      input.value = formatZip(zip);
    });
  }

  function setShippingQuote(zip, address, rates) {
    const bestRate = selectBestShippingRate(rates);

    if (!bestRate) {
      cartShippingQuote = null;
      persistShippingQuote();
      renderShippingSummary();
      return;
    }

    cartShippingQuote = {
      zip: sanitizeZip(zip),
      address: address || null,
      rate: bestRate,
    };
    persistShippingQuote();
    renderShippingSummary();
  }

  function clearShippingQuote() {
    cartShippingQuote = null;
    persistShippingQuote();
    renderShippingSummary();
  }

  function selectBestShippingRate(rates) {
    if (!Array.isArray(rates) || !rates.length) {
      return null;
    }

    return rates.slice().sort((left, right) => {
      const leftPrice = parseShippingPrice(left.price);
      const rightPrice = parseShippingPrice(right.price);

      if (leftPrice === rightPrice) return 0;
      return leftPrice - rightPrice;
    })[0] || null;
  }

  function parseShippingPrice(value) {
    const digits = String(value || '').replace(/[^\d]/g, '');
    return Number(digits || '0');
  }

  function formatCentsBR(value) {
    const cents = Number(value || 0);
    const amount = (cents / 100).toFixed(2).replace('.', ',');
    return `R$ ${amount}`;
  }

  function formatShippingRate(rate) {
    if (!rate) return 'Calculado no checkout';

    const cents = parseShippingPrice(rate.price);
    if (!cents) return 'R$ 0,00';

    return formatCentsBR(cents);
  }

  function displayShippingRateName(rate) {
    const name = String(rate && rate.name ? rate.name : '').trim();

    // A Shopify entrega o nome técnico da modalidade local, em vez do nome
    // configurado na zona de entrega. Mantemos as demais tarifas intactas.
    return /^local\s+delivery$/i.test(name) ? 'Retire no local' : (name || 'Frete');
  }

  function formatDiscountSummary() {
    document.querySelectorAll('[data-cart-discount-summary-value]').forEach((summaryElement) => {
      const discountCents = Number(summaryElement.dataset.discountCents || '0');
      summaryElement.textContent = discountCents > 0 ? formatCentsBR(discountCents) : 'R$ 0,00';
    });
  }

  function getCartSubtotalCents() {
    const subtotalElement = document.querySelector('[data-cart-subtotal-cents]');
    if (!subtotalElement) return 0;

    return Number(subtotalElement.dataset.cartSubtotalCents || '0');
  }

  function renderCartTotalAfterDiscount() {
    const subtotalCents = getCartSubtotalCents();
    const discountCents = Number(document.querySelector('[data-cart-discount-summary-value]')?.dataset.discountCents || '0');
    const shippingCents = cartShippingQuote && cartShippingQuote.rate ? parseShippingPrice(cartShippingQuote.rate.price) : 0;
    const totalCents = Math.max(0, subtotalCents - discountCents + shippingCents);

    document.querySelectorAll('[data-cart-total-after-discount-value]').forEach((element) => {
      element.textContent = formatCentsBR(totalCents);
    });
  }

  function renderShippingSummary() {
    const summaryValue = formatShippingRate(cartShippingQuote && cartShippingQuote.rate);
    document.querySelectorAll('[data-cart-shipping-summary-value]').forEach((element) => {
      element.textContent = summaryValue;
    });
    formatDiscountSummary();
    renderCartTotalAfterDiscount();
  }

  function formatShippingAddress(address, zip) {
    if (!address) return '';

    const parts = [];
    const street = [address.address1, address.neighborhood].filter(Boolean).join(' • ');
    const locality = [address.city, address.provinceName || address.province].filter(Boolean).join(' / ');

    if (street) parts.push(street);
    if (locality) parts.push(locality);
    if (zip) parts.push(formatZip(zip));

    return parts.join(' • ');
  }

  function renderShippingAddress(target, address, zip) {
    if (!target) return;

    const text = formatShippingAddress(address, zip);
    if (!text) {
      target.textContent = '';
      target.hidden = true;
      return;
    }

    target.textContent = `Endereço estimado: ${text}`;
    target.hidden = false;
  }

  function initKeenCardCarousel(sliderElement, options) {
    const shell = sliderElement.closest(options.shellSelector);
    const prevButton = shell ? shell.querySelector(options.prevSelector) : null;
    const nextButton = shell ? shell.querySelector(options.nextSelector) : null;
    const dotsContainer = shell ? shell.querySelector(options.dotsSelector) : null;
    const slideCount = sliderElement.querySelectorAll('.keen-slider__slide').length;

    if (prevButton) prevButton.disabled = slideCount <= 1;
    if (nextButton) nextButton.disabled = slideCount <= 1;
    if (dotsContainer) dotsContainer.hidden = slideCount <= 1;

    const dotButtons = [];

    if (dotsContainer && slideCount > 1) {
      dotsContainer.innerHTML = '';
      for (let index = 0; index < slideCount; index += 1) {
        const dot = document.createElement('button');
        dot.className = 'featured-products__dot';
        dot.type = 'button';
        dot.setAttribute('aria-label', `Ir para o item ${index + 1}`);
        dotsContainer.appendChild(dot);
        dotButtons.push(dot);
      }
    }

    const slider = new KeenSlider(sliderElement, {
      loop: slideCount > 1,
      renderMode: 'performance',
      drag: true,
      slides: {
        perView: 'auto',
        spacing: 16,
      },
      created(instance) {
        if (prevButton) {
          prevButton.addEventListener('click', () => instance.prev());
        }
        if (nextButton) {
          nextButton.addEventListener('click', () => instance.next());
        }
        if (dotsContainer && dotButtons.length) {
          dotButtons[0].classList.add('is-active');
          dotButtons.forEach((dot, index) => {
            dot.addEventListener('click', () => instance.moveToIdx(index));
          });
        }
      },
      slideChanged(instance) {
        if (!dotsContainer || !dotButtons.length) return;
        dotButtons.forEach((dot, index) => {
          dot.classList.toggle('is-active', index === instance.track.details.rel);
        });
      },
    });

    window.addEventListener('resize', () => {
      slider.update();
    }, { passive: true });

    return slider;
  }

  function brazilianStateName(code) {
    const normalized = String(code || '').trim().toUpperCase();
    const states = {
      AC: 'Acre',
      AL: 'Alagoas',
      AP: 'Amapá',
      AM: 'Amazonas',
      BA: 'Bahia',
      CE: 'Ceará',
      DF: 'Distrito Federal',
      ES: 'Espírito Santo',
      GO: 'Goiás',
      MA: 'Maranhão',
      MT: 'Mato Grosso',
      MS: 'Mato Grosso do Sul',
      MG: 'Minas Gerais',
      PA: 'Pará',
      PB: 'Paraíba',
      PR: 'Paraná',
      PE: 'Pernambuco',
      PI: 'Piauí',
      RJ: 'Rio de Janeiro',
      RN: 'Rio Grande do Norte',
      RS: 'Rio Grande do Sul',
      RO: 'Rondônia',
      RR: 'Roraima',
      SC: 'Santa Catarina',
      SP: 'São Paulo',
      SE: 'Sergipe',
      TO: 'Tocantins',
    };

    return states[normalized] || normalized;
  }

  async function resolveCepAddress(zip) {
    const sanitizedZip = sanitizeZip(zip);
    if (sanitizedZip.length !== 8) return null;

    try {
      const response = await fetch(`https://viacep.com.br/ws/${sanitizedZip}/json/`, {
        credentials: 'omit',
      });

      if (!response.ok) return null;

      const data = await response.json();
      if (!data || data.erro) return null;

      return {
        zip: sanitizedZip,
        address1: data.logradouro || '',
        neighborhood: data.bairro || '',
        city: data.localidade || '',
        province: data.uf || '',
        provinceName: brazilianStateName(data.uf || ''),
        country: 'Brazil',
        countryCode: 'BR',
      };
    } catch (error) {
      return null;
    }
  }

  const focusablesSelector = 'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])';

  function buildCheckoutUrl(baseUrl) {
    return new URL(baseUrl || '/checkout', window.location.origin);
  }

  function buildCheckoutUrlWithAddress(address, checkoutBaseUrl) {
    const url = new URL(checkoutBaseUrl || '/checkout', window.location.origin);

    url.searchParams.set('checkout[shipping_address][country]', address.country || 'Brazil');
    url.searchParams.set('checkout[shipping_address][country_code]', address.countryCode || 'BR');
    url.searchParams.set('checkout[shipping_address][zip]', formatZip(address.zip || getPreferredShippingZip() || ''));
    url.searchParams.set('checkout[shipping_address][province]', address.province || address.provinceName || '');
    url.searchParams.set('checkout[shipping_address][province_code]', address.provinceCode || address.province || '');
    url.searchParams.set('checkout[shipping_address][city]', address.city || '');

    if (address.address1) {
      url.searchParams.set('checkout[shipping_address][address1]', address.address1);
    }

    if (address.neighborhood) {
      url.searchParams.set('checkout[shipping_address][address2]', `\u2060${address.neighborhood}`);
      url.searchParams.set('checkout[shipping_address][neighborhood]', address.neighborhood);
      url.searchParams.set('checkout[shipping_address][shipping_neighborhood]', address.neighborhood);
      url.searchParams.set('shipping_neighborhood', address.neighborhood);
      url.searchParams.set('neighborhood', address.neighborhood);
    }

    url.searchParams.set('checkout[shipping_address][countryCode]', address.countryCode || 'BR');
    url.searchParams.set('checkout[shipping_address][postalCode]', formatZip(address.zip || getPreferredShippingZip() || ''));
    url.searchParams.set('checkout[shipping_address][zone]', address.provinceCode || address.province || '');
    url.searchParams.set('checkout[shipping_address][streetName]', address.address1 || '');

    return url;
  }

  const storedShippingState = readShippingState();
  if (storedShippingState) {
    cartShippingZip = sanitizeZip(storedShippingState.zip);
    cartShippingAddress = storedShippingState.address || null;
  }

  try {
    const storedQuote = window.sessionStorage.getItem(shippingQuoteKey);
    if (storedQuote) {
      cartShippingQuote = JSON.parse(storedQuote);
    }
  } catch (error) {
    cartShippingQuote = null;
  }

  syncShippingZipInputs();
  renderShippingSummary();

  function getAutoRefreshShippingForm() {
    const context = body.classList.contains('template-cart') ? 'page' : 'drawer';
    return document.querySelector(`[data-cart-shipping-form][data-cart-shipping-context="${context}"]`);
  }

  function submitShippingForm(form) {
    if (!form) return;

    const submitButton = form.querySelector('button[type="submit"]');
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitButton || undefined);
    } else if (submitButton) {
      submitButton.click();
    } else {
      form.submit();
    }
  }

  function autoRefreshCartShippingQuote() {
    if (cartShippingAutoRefreshRequested) return;

    const form = getAutoRefreshShippingForm();
    if (!form) return;
    if (String(form.dataset.cartRequiresShipping || 'true') !== 'true') return;

    const zip = getPreferredShippingZip();
    if (!zip) return;

    const input = form.querySelector('input[name="checkout[shipping_address][zip]"]');
    if (input) {
      input.value = formatZip(zip);
    }

    cartShippingAutoRefreshRequested = true;
    window.requestAnimationFrame(() => {
      if (!form.isConnected) return;
      submitShippingForm(form);
    });
  }

  if (drawer && openButtons.length) {
    function setOpen(isOpen) {
      drawer.classList.toggle('is-open', isOpen);
      body.classList.toggle('has-open-drawer', isOpen);
      drawer.setAttribute('aria-hidden', String(!isOpen));

      openButtons.forEach((button) => {
        button.setAttribute('aria-expanded', String(isOpen));
      });

      if (!isOpen) {
        if (lastTrigger) lastTrigger.focus();
        return;
      }

      const firstFocusable = drawer.querySelector(focusablesSelector);
      if (firstFocusable) firstFocusable.focus();
    }

    openButtons.forEach((button) => {
      button.addEventListener('click', () => {
        lastTrigger = button;
        setOpen(true);
      });
    });

    closeButtons.forEach((button) => {
      button.addEventListener('click', () => setOpen(false));
    });

    drawer.addEventListener('click', (event) => {
      if (event.target.matches('[data-drawer-overlay]')) {
        setOpen(false);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        setOpen(false);
      }
    });
  }

  function setCartOpen(isOpen) {
    if (!cartDrawer) return;
    cartDrawer.classList.toggle('is-open', isOpen);
    body.classList.toggle('has-open-drawer', isOpen);
    cartDrawer.setAttribute('aria-hidden', String(!isOpen));
    if (cartOpenButton) cartOpenButton.setAttribute('aria-expanded', String(isOpen));
    persistCartDrawerState(isOpen);

    if (!isOpen) {
      if (lastCartTrigger) lastCartTrigger.focus();
      return;
    }

    const firstFocusable = cartDrawer.querySelector(focusablesSelector);
    if (firstFocusable) firstFocusable.focus();
  }

  function updateCartBadge(itemCount) {
    if (!cartOpenButton) return;
    const count = Number(itemCount) || 0;
    let badge = cartOpenButton.querySelector('.site-header__cart-badge');
    cartOpenButton.setAttribute('aria-label', `Abrir carrinho (${count})`);

    if (count <= 0) {
      if (badge) badge.remove();
      return;
    }

    if (!badge) {
      badge = document.createElement('span');
      badge.className = 'site-header__cart-badge';
      badge.setAttribute('aria-hidden', 'true');
      cartOpenButton.appendChild(badge);
    }
    badge.textContent = String(count);
  }

  // Troca o conteúdo da gaveta pelo HTML novo da seção "cart-drawer"
  // (Section Rendering API), sem recarregar a página.
  function renderCartDrawer(sectionHtml) {
    if (!cartDrawer || !sectionHtml) return false;
    const parsed = new DOMParser().parseFromString(sectionHtml, 'text/html');
    const nextPanel = parsed.querySelector('.cart-drawer__panel');
    const currentPanel = cartDrawer.querySelector('.cart-drawer__panel');
    if (!nextPanel || !currentPanel) return false;

    currentPanel.innerHTML = nextPanel.innerHTML;
    updateCartBadge(currentPanel.querySelector('[data-cart-item-count]')?.dataset.cartItemCount);
    currentPanel.querySelectorAll('[data-cart-shipping-form]').forEach(initCartShippingForm);
    syncShippingZipInputs();
    renderShippingSummary();
    return true;
  }

  // Envia para a API do carrinho pedindo a seção da gaveta junto.
  // Retorna true se a gaveta foi atualizada; false para o chamador cair no recarregamento.
  async function requestCart(endpoint, formData) {
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);

    const response = await fetch(`${rootUrl}${endpoint}`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { Accept: 'application/json' },
      body: formData,
    });

    let data = null;
    try {
      data = await response.json();
    } catch (error) {
      data = null;
    }

    if (!response.ok) {
      const error = new Error((data && data.description) || 'cart_request_failed');
      error.description = data && data.description;
      throw error;
    }

    return renderCartDrawer(data && data.sections && data.sections['cart-drawer']);
  }

  async function updateCartDrawer(endpoint, formData) {
    if (cartDrawer) cartDrawer.classList.add('is-updating');
    try {
      return await requestCart(endpoint, formData);
    } finally {
      if (cartDrawer) cartDrawer.classList.remove('is-updating');
    }
  }

  if (cartDrawer && cartOpenButton) {
    cartOpenButton.addEventListener('click', (event) => {
      event.preventDefault();
      lastCartTrigger = cartOpenButton;
      const isOpen = cartDrawer.classList.contains('is-open');
      setCartOpen(!isOpen);
    });

    cartDrawer.addEventListener('click', (event) => {
      if (event.target.matches('[data-cart-drawer-overlay]') || event.target.closest('[data-close-cart]')) {
        setCartOpen(false);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && cartDrawer.classList.contains('is-open')) {
        setCartOpen(false);
      }
    });

    if (window.sessionStorage.getItem(cartDrawerStateKey) === '1') {
      setCartOpen(true);
    }
  }

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-checkout]');
    if (!button) return;
    event.preventDefault();

    const checkoutUrl = button.dataset.checkoutUrl || (cartDrawer && cartDrawer.dataset.checkoutUrl) || '/checkout';
    const address = cartShippingAddress || readShippingState()?.address || null;
    const targetUrl = buildCheckoutUrlWithAddress(address || {}, checkoutUrl);
    window.location.assign(targetUrl.toString());
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;

    if (form.matches('.cart-drawer__items-form, .cart-page__items-form')) {
      event.preventDefault();
      const inDrawer = Boolean(form.closest('[data-cart-drawer]'));
      clearShippingQuote();

      try {
        if (inDrawer && await updateCartDrawer('cart/update.js', new FormData(form))) return;
        if (!inDrawer) {
          await fetch('/cart/update.js', {
            method: 'POST',
            headers: { Accept: 'application/json' },
            body: new FormData(form),
          });
        }
        if (inDrawer) persistCartDrawerState(true);
        window.location.reload();
      } catch (error) {
        form.submit();
      }
      return;
    }

    // Upsell da gaveta e botão rápido dos cards de produto usam o mesmo fluxo.
    if (form.matches('[data-cart-upsell-form], [data-quick-add-form]')) {
      event.preventDefault();
      const isQuickAdd = form.matches('[data-quick-add-form]');
      const button = form.querySelector('button[type="submit"]');
      const originalLabel = button ? button.innerHTML : '';
      if (button) {
        button.disabled = true;
        button.textContent = 'Adicionando...';
      }

      try {
        clearShippingQuote();
        if (!await updateCartDrawer('cart/add.js', new FormData(form))) {
          persistCartDrawerState(true);
          window.location.reload();
          return;
        }
        if (isQuickAdd && button) {
          button.disabled = false;
          button.innerHTML = originalLabel;
          lastCartTrigger = button;
          setCartOpen(true);
        }
      } catch (error) {
        if (button) {
          button.disabled = false;
          button.textContent = error.description ? 'Indisponível' : 'Tentar de novo';
        }
      }
      return;
    }

    if (form.matches('[data-cart-coupon-form]')) {
      event.preventDefault();
      const input = form.querySelector('input[name="discount"]');
      const checkoutUrl = form.dataset.checkoutUrl || '/checkout';
      const code = String(input && input.value ? input.value : '').trim();
      if (!code) return;

      window.location.assign(`/discount/${encodeURIComponent(code)}?redirect=${encodeURIComponent(checkoutUrl)}`);
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-remove]');
    if (!button) return;

    const form = button.closest('form');
    if (!form) return;

    const item = button.closest('[data-cart-item]');
    const quantityInput = item && item.querySelector('[data-cart-quantity-input]');
    if (!quantityInput) return;

    event.preventDefault();
    quantityInput.value = '0';

    const submitButton = form.querySelector('button[type="submit"][name="update"]');
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitButton || undefined);
    } else if (submitButton) {
      submitButton.click();
    } else {
      form.submit();
    }
  });

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cart-quantity-step]');
    if (!button) return;

    const stepper = button.closest('[data-cart-quantity-stepper]');
    if (!stepper) return;

    const input = stepper.querySelector('[data-cart-quantity-input]');
    const form = stepper.closest('form');
    if (!input || !form) return;

    event.preventDefault();

    const step = Number(button.dataset.cartQuantityStep || 0);
    const min = Number(input.min || 0);
    const currentValue = Number(input.value || min);
    const nextValue = Math.max(min, currentValue + step);

    input.value = String(nextValue);

    const submitButton = form.querySelector('button[type="submit"][name="update"]');
    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit(submitButton || undefined);
    } else if (submitButton) {
      submitButton.click();
    } else {
      form.submit();
    }
  });

  document.querySelectorAll('.cart-page__items-form [data-cart-quantity-input]').forEach((input) => {
    input.addEventListener('change', () => {
      const form = input.closest('form');
      if (!form) return;

      const submitButton = form.querySelector('button[type="submit"][name="update"]');
      if (typeof form.requestSubmit === 'function') {
        form.requestSubmit(submitButton || undefined);
      } else if (submitButton) {
        submitButton.click();
      } else {
        form.submit();
      }
    });
  });

  function initCartShippingForm(form) {
    if (form.dataset.cartShippingReady === 'true') return;
    form.dataset.cartShippingReady = 'true';

    const input = form.querySelector('input[name="checkout[shipping_address][zip]"]');
    const status = form.querySelector('[data-cart-shipping-status]');
    const address = form.querySelector('[data-cart-shipping-address]');
    const results = form.querySelector('[data-cart-shipping-results]');
    const checkoutUrl = form.dataset.checkoutUrl || '/checkout';
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const cartRequiresShipping = String(form.dataset.cartRequiresShipping || 'true') === 'true';
    let lastRequestedZip = '';

    if (input) {
      input.value = formatZip(getPreferredShippingZip());
    }
    renderShippingAddress(address, cartShippingAddress, getPreferredShippingZip());

    function setStatus(message, isError) {
      if (!status) return;
      status.textContent = message;
      status.classList.toggle('is-error', Boolean(isError));
    }

    function renderRates(rates) {
      if (!results) return;

      if (!rates || !rates.length) {
        results.innerHTML = '<p class="cart-drawer__shipping-empty">Nenhuma opção de frete disponível para este CEP.</p>';
        results.hidden = false;
        return;
      }

      results.innerHTML = rates.map((rate) => {
        const deliveryDays = Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0
          ? `${rate.delivery_days[0]}-${rate.delivery_days[rate.delivery_days.length - 1]} dias úteis`
          : 'Prazo informado no checkout';

        return `
          <article class="cart-drawer__shipping-rate">
            <div>
              <strong>${displayShippingRateName(rate)}</strong>
              <p>${deliveryDays}</p>
            </div>
            <span>${formatShippingRate(rate)}</span>
          </article>
        `;
      }).join('');
      results.hidden = false;
    }

    async function loadRates(zip, address) {
      const params = new URLSearchParams({
        'shipping_address[zip]': zip,
        'shipping_address[country]': 'Brazil',
      });

      if (address) {
        if (address.address1) params.set('shipping_address[address1]', address.address1);
        if (address.neighborhood) params.set('shipping_address[address2]', address.neighborhood);
        if (address.city) params.set('shipping_address[city]', address.city);
        if (address.provinceName || address.province) {
          params.set('shipping_address[province]', address.provinceName || address.province);
        }
      }

      const query = params.toString();

      const prepared = await fetch(`${rootUrl}cart/prepare_shipping_rates.json?${query}`, {
        method: 'POST',
        credentials: 'same-origin',
      });

      const preparedAccepted = prepared.ok || prepared.status === 202;

      if (preparedAccepted) {
        for (let index = 0; index < 20; index += 1) {
          const response = await fetch(`${rootUrl}cart/async_shipping_rates.json?${query}`, {
            credentials: 'same-origin',
          });

          if (response.ok) {
            const data = await response.json();
            if (data && Array.isArray(data.shipping_rates) && data.shipping_rates.length > 0) {
              return data.shipping_rates;
            }
          }

          if (response.status !== 422) {
            await new Promise((resolve) => window.setTimeout(resolve, 500));
            continue;
          }

          break;
        }
      }

      const fallbackResponse = await fetch(`${rootUrl}cart/shipping_rates.json?${query}`, {
        credentials: 'same-origin',
      });

      if (fallbackResponse.ok) {
        const data = await fallbackResponse.json();
        if (data && Array.isArray(data.shipping_rates) && data.shipping_rates.length > 0) {
          return data.shipping_rates;
        }
      }

      return [];
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      if (!cartRequiresShipping) {
        setStatus('Este carrinho não exige frete. Verifique se o produto está marcado como físico e se a configuração de entrega está ativa.', true);
        if (results) results.hidden = true;
        if (address) renderShippingAddress(address, null, '');
        return;
      }

      const zip = sanitizeZip(input && input.value ? input.value : '');
      if (!zip) {
        setStatus('Digite um CEP válido para calcular o frete.', true);
        if (results) results.hidden = true;
        if (address) renderShippingAddress(address, null, '');
        return;
      }

      setShippingState(zip, null);
      lastRequestedZip = zip;
      setStatus('Calculando frete...', false);
      if (results) results.hidden = true;
      renderShippingAddress(address, null, zip);

      try {
        const resolvedAddress = await resolveCepAddress(zip);
        const rates = await loadRates(zip, resolvedAddress || cartShippingAddress || null);

        if (lastRequestedZip !== zip) return;
        setShippingState(zip, resolvedAddress);
        setShippingQuote(zip, resolvedAddress, rates);
        setStatus(rates.length ? `Frete estimado para ${zip}` : 'Não encontramos frete para este CEP.', !rates.length);
        renderShippingAddress(address, resolvedAddress, zip);
        renderRates(rates);
      } catch (error) {
        if (lastRequestedZip !== zip) return;
        setStatus('Não foi possível calcular o frete agora.', true);
        renderShippingAddress(address, null, zip);
        if (results) results.hidden = true;
        setShippingQuote(zip, null, null);
      }
    });
  }

  document.querySelectorAll('[data-cart-shipping-form]').forEach(initCartShippingForm);

  document.querySelectorAll('[data-product-shipping-form]').forEach((form) => {
    const input = form.querySelector('[data-product-shipping-zip]');
    const status = form.querySelector('[data-product-shipping-status]');
    const address = form.querySelector('[data-product-shipping-address]');
    const results = form.querySelector('[data-product-shipping-results]');
    const variantInput = form.closest('[data-product-section]')?.querySelector('[data-variant-id]');
    const quantityInput = form.closest('[data-product-section]')?.querySelector('[name="quantity"]');
    const rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    const productCartItemCount = Number(form.dataset.productCartItemCount || '0');
    const productHasItemsInCart = !Number.isNaN(productCartItemCount) && productCartItemCount > 0;

    if (!input || !status || !results) return;

    if (input) {
      input.value = formatZip(getPreferredShippingZip());
    }
    renderShippingAddress(address, cartShippingAddress, getPreferredShippingZip());

    const delay = (ms) => new Promise((resolve) => window.setTimeout(resolve, ms));

    function setStatus(message, isError) {
      status.textContent = message;
      status.classList.toggle('is-error', Boolean(isError));
    }

    function renderRates(rates) {
      if (!rates || !rates.length) {
        results.innerHTML = '<p class="product-shipping-estimator__empty">Nenhuma opção de frete disponível para este CEP.</p>';
        results.hidden = false;
        return;
      }

      results.innerHTML = rates.map((rate) => {
        const deliveryDays = Array.isArray(rate.delivery_days) && rate.delivery_days.length > 0
          ? `${rate.delivery_days[0]}-${rate.delivery_days[rate.delivery_days.length - 1]} dias úteis`
          : 'Prazo informado no checkout';

        return `
          <article class="product-shipping-estimator__rate">
            <div>
              <strong>${displayShippingRateName(rate)}</strong>
              <p>${deliveryDays}</p>
            </div>
            <span>${formatShippingRate(rate)}</span>
          </article>
        `;
      }).join('');
      results.hidden = false;
    }

    async function loadRates(zip, address) {
      const params = new URLSearchParams({
        'shipping_address[zip]': zip,
        'shipping_address[country]': 'Brazil',
      });

      if (address) {
        if (address.address1) params.set('shipping_address[address1]', address.address1);
        if (address.neighborhood) params.set('shipping_address[address2]', address.neighborhood);
        if (address.city) params.set('shipping_address[city]', address.city);
        if (address.provinceName || address.province) {
          params.set('shipping_address[province]', address.provinceName || address.province);
        }
      }

      const query = params.toString();

      const prepared = await fetch(`${rootUrl}cart/prepare_shipping_rates.json?${query}`, {
        method: 'POST',
        credentials: 'same-origin',
      });

      const preparedAccepted = prepared.ok || prepared.status === 202;

      if (preparedAccepted) {
        for (let index = 0; index < 20; index += 1) {
          const response = await fetch(`${rootUrl}cart/async_shipping_rates.json?${query}`, {
            credentials: 'same-origin',
          });

          if (response.ok) {
            const data = await response.json();
            if (data && Array.isArray(data.shipping_rates) && data.shipping_rates.length > 0) {
              return data.shipping_rates;
            }
          }

          if (response.status !== 422) {
            await delay(500);
            continue;
          }

          break;
        }
      }

      const fallbackResponse = await fetch(`${rootUrl}cart/shipping_rates.json?${query}`, {
        credentials: 'same-origin',
      });

      if (fallbackResponse.ok) {
        const data = await fallbackResponse.json();
        if (data && Array.isArray(data.shipping_rates) && data.shipping_rates.length > 0) {
          return data.shipping_rates;
        }
      }

      return [];
    }

    async function addTemporaryProductToCart() {
      const variantId = Number(variantInput && variantInput.value);
      const quantity = Math.max(1, Number(quantityInput && quantityInput.value) || 1);

      if (!variantId) return false;

      const response = await fetch(`${rootUrl}cart/add.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({
          items: [{ id: variantId, quantity }],
        }),
      });

      return response.ok;
    }

    async function clearTemporaryCart() {
      await fetch(`${rootUrl}cart/clear.js`, {
        method: 'POST',
        credentials: 'same-origin',
      });
    }

    async function getCartItemCount() {
      const response = await fetch(`${rootUrl}cart.js`, {
        credentials: 'same-origin',
      });

      if (!response.ok) {
        return productHasItemsInCart;
      }

      const cart = await response.json();
      return Number(cart && cart.item_count ? cart.item_count : 0) > 0;
    }

    form.addEventListener('submit', async (event) => {
      event.preventDefault();

      const zip = sanitizeZip(input.value || '');
      if (!zip) {
        setStatus('Digite um CEP válido para calcular o frete.', true);
        results.hidden = true;
        renderShippingAddress(address, null, '');
        return;
      }

      setShippingState(zip, null);
      setStatus('Calculando frete...', false);
      results.hidden = true;
      renderShippingAddress(address, null, zip);

      let addedTemporaryProduct = false;

      try {
        const resolvedAddress = await resolveCepAddress(zip);
        const hasItemsInCartNow = await getCartItemCount();

        if (!hasItemsInCartNow) {
          addedTemporaryProduct = await addTemporaryProductToCart();
          if (addedTemporaryProduct) {
            await delay(300);
          }
        }

        if (!hasItemsInCartNow && !addedTemporaryProduct) {
          setStatus('Não foi possível preparar o produto para calcular o frete.', true);
          renderShippingAddress(address, null, zip);
          return;
        }

        const rates = await loadRates(zip, resolvedAddress || cartShippingAddress || null);

        setShippingState(zip, resolvedAddress);
        setShippingQuote(zip, resolvedAddress, rates);
        setStatus(rates.length ? `Frete estimado para ${zip}` : 'Não encontramos frete para este CEP.', !rates.length);
        renderShippingAddress(address, resolvedAddress, zip);
        renderRates(rates);
      } catch (error) {
        setStatus('Não foi possível calcular o frete agora.', true);
        renderShippingAddress(address, null, zip);
        results.hidden = true;
        setShippingQuote(zip, null, null);
      } finally {
        if (addedTemporaryProduct) {
          await clearTemporaryCart();
        }
      }
    });
  });

  autoRefreshCartShippingQuote();

  if (searchDropdown && searchToggle && searchPanel) {
    const searchInput = searchPanel.querySelector('input[type="search"]');

    function setSearchOpen(isOpen) {
      searchToggle.setAttribute('aria-expanded', String(isOpen));
      searchPanel.hidden = !isOpen;

      if (isOpen && searchInput) {
        window.requestAnimationFrame(() => searchInput.focus());
      }
    }

    searchToggle.addEventListener('click', () => {
      const isOpen = searchToggle.getAttribute('aria-expanded') === 'true';
      setSearchOpen(!isOpen);
    });

    document.addEventListener('click', (event) => {
      if (!searchDropdown.contains(event.target)) {
        setSearchOpen(false);
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        setSearchOpen(false);
      }
    });
  }

  const headerDropdowns = Array.from(document.querySelectorAll('[data-header-dropdown]'));
  if (headerDropdowns.length) {
    const isDesktopHeader = window.matchMedia('(min-width: 1024px)');
    const closeHeaderDropdowns = (except) => {
      headerDropdowns.forEach((dropdown) => {
        if (dropdown !== except) {
          dropdown.removeAttribute('open');
        }
      });
    };

    headerDropdowns.forEach((dropdown) => {
      const summary = dropdown.querySelector('summary');
      if (!summary) return;

      summary.addEventListener('click', () => {
        const willOpen = !dropdown.open;
        window.requestAnimationFrame(() => {
          if (willOpen) {
            closeHeaderDropdowns(dropdown);
          }
        });
      });

      dropdown.addEventListener('mouseenter', () => {
        if (!isDesktopHeader.matches) return;
        dropdown.setAttribute('open', '');
        closeHeaderDropdowns(dropdown);
      });

      dropdown.addEventListener('mouseleave', () => {
        if (!isDesktopHeader.matches) return;
        if (!dropdown.matches(':focus-within')) {
          dropdown.removeAttribute('open');
        }
      });

      dropdown.addEventListener('focusin', () => {
        if (!isDesktopHeader.matches) return;
        dropdown.setAttribute('open', '');
        closeHeaderDropdowns(dropdown);
      });
    });

    document.addEventListener('click', (event) => {
      const insideDropdown = event.target.closest('[data-header-dropdown]');
      if (!insideDropdown) {
        closeHeaderDropdowns();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeHeaderDropdowns();
      }
    });
  }

  const featuredSliders = Array.from(document.querySelectorAll('[data-featured-slider]'));
  if (featuredSliders.length && window.KeenSlider) {
    featuredSliders.forEach((sliderElement) => {
      initKeenCardCarousel(sliderElement, {
        shellSelector: '.featured-products__carousel-shell',
        prevSelector: '[data-featured-prev]',
        nextSelector: '[data-featured-next]',
        dotsSelector: '[data-featured-dots]',
      });
    });
  }

  const relatedSliders = Array.from(document.querySelectorAll('[data-related-slider]'));
  if (relatedSliders.length && window.KeenSlider) {
    relatedSliders.forEach((sliderElement) => {
      initKeenCardCarousel(sliderElement, {
        shellSelector: '.product-page__related-carousel-shell',
        prevSelector: '[data-related-prev]',
        nextSelector: '[data-related-next]',
        dotsSelector: '[data-related-dots]',
      });
    });
  }

  document.querySelectorAll('.collection-filters').forEach((form) => {
    const collapseToggle = form.querySelector('[data-collection-filters-toggle]');
    const priceSliders = Array.from(form.querySelectorAll('[data-price-slider]'));

    function setCollapsed(isCollapsed) {
      form.classList.toggle('is-collapsed', isCollapsed);
      if (collapseToggle) {
        collapseToggle.setAttribute('aria-expanded', String(!isCollapsed));
        collapseToggle.textContent = isCollapsed ? 'Mostrar filtros' : 'Ocultar filtros';
      }
    }

    if (collapseToggle) {
      setCollapsed(false);

      collapseToggle.addEventListener('click', () => {
        if (!window.matchMedia('(max-width: 749px)').matches) return;
        setCollapsed(!form.classList.contains('is-collapsed'));
      });

      window.addEventListener('resize', () => {
        if (!window.matchMedia('(max-width: 749px)').matches) {
          setCollapsed(false);
        }
      }, { passive: true });
    }

    priceSliders.forEach((slider) => {
      const sliderUi = slider.querySelector('[data-price-slider-ui]');
      const minHidden = slider.querySelector('[data-range-min-hidden]');
      const maxHidden = slider.querySelector('[data-range-max-hidden]');
      const minLabel = slider.querySelector('[data-range-min-value]');
      const maxLabel = slider.querySelector('[data-range-max-value]');
      const minField = slider.querySelector('[data-range-min-field]');
      const maxField = slider.querySelector('[data-range-max-field]');
      const rangeMax = Number(slider.dataset.rangeMax || 0);
      const priceFactor = 100;
      const displayRangeMax = rangeMax / priceFactor;
      const startMin = Number(slider.dataset.currentMin || 0);
      const startMax = Number(slider.dataset.currentMax || displayRangeMax);
      const step = 0.01;

      if (!sliderUi || !minHidden || !maxHidden || !minLabel || !maxLabel || !minField || !maxField || !rangeMax || !window.noUiSlider) {
        return;
      }

      const normalizedMin = Math.max(0, Math.min(startMin, displayRangeMax));
      const normalizedMax = Math.max(normalizedMin, Math.min(startMax, displayRangeMax));
      let lastValues = [normalizedMin, normalizedMax];

      if (sliderUi.noUiSlider) {
        sliderUi.noUiSlider.destroy();
      }

      window.noUiSlider.create(sliderUi, {
        start: [normalizedMin, normalizedMax],
        connect: true,
        step,
        range: {
          min: 0,
          max: displayRangeMax,
        },
        behaviour: 'tap-drag',
        keyboardSupport: true,
        format: {
          to: (value) => Number(value).toFixed(2),
          from: (value) => Number(value),
        },
      });

      function syncValues(values, handle, unencoded) {
        const minValue = Math.max(0, Math.min(Number(unencoded[0] || 0), displayRangeMax));
        const maxValue = Math.max(0, Math.min(Number(unencoded[1] || displayRangeMax), displayRangeMax));
        lastValues = [minValue, maxValue];

        minLabel.textContent = formatMoney(Math.round(minValue * priceFactor));
        maxLabel.textContent = formatMoney(Math.round(maxValue * priceFactor));
        minField.value = minValue.toFixed(2);
        maxField.value = maxValue.toFixed(2);

        if (minValue <= 0) {
          minHidden.disabled = true;
          minHidden.value = '';
        } else {
          minHidden.disabled = false;
          minHidden.value = minValue.toFixed(2);
        }

        if (maxValue >= displayRangeMax) {
          maxHidden.disabled = true;
          maxHidden.value = '';
        } else {
          maxHidden.disabled = false;
          maxHidden.value = maxValue.toFixed(2);
        }
      }

      function syncFieldValue(index, field) {
        const nextValue = Number(field.value || 0);
        if (Number.isNaN(nextValue)) return;

        const nextValues = lastValues.slice();
        nextValues[index] = Math.max(0, Math.min(nextValue, displayRangeMax));
        nextValues[0] = Math.min(nextValues[0], nextValues[1]);
        nextValues[1] = Math.max(nextValues[0], nextValues[1]);
        sliderUi.noUiSlider.set(nextValues);
      }

      function syncSliderToForm() {
        const values = sliderUi.noUiSlider.get();
        const minValue = Math.max(0, Math.min(Number(values[0] || 0), displayRangeMax));
        const maxValue = Math.max(0, Math.min(Number(values[1] || displayRangeMax), displayRangeMax));

        minField.value = minValue.toFixed(2);
        maxField.value = maxValue.toFixed(2);

        if (minValue <= 0) {
          minHidden.disabled = true;
          minHidden.value = '';
        } else {
          minHidden.disabled = false;
          minHidden.value = minValue.toFixed(2);
        }

        if (maxValue >= displayRangeMax) {
          maxHidden.disabled = true;
          maxHidden.value = '';
        } else {
          maxHidden.disabled = false;
          maxHidden.value = maxValue.toFixed(2);
        }
      }

      function submitCollectionFiltersForm() {
        syncSliderToForm();

        const formData = new FormData(form);
        const targetUrl = new URL(form.getAttribute('action') || window.location.href, window.location.origin);
        const nextParams = new URLSearchParams(formData);

        targetUrl.search = '';
        nextParams.forEach((value, key) => {
          targetUrl.searchParams.append(key, value);
        });

        window.location.assign(targetUrl.toString());
      }

      sliderUi.noUiSlider.on('update', syncValues);
      minField.addEventListener('change', () => syncFieldValue(0, minField));
      maxField.addEventListener('change', () => syncFieldValue(1, maxField));
      syncValues(null, null, [normalizedMin, normalizedMax]);
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        submitCollectionFiltersForm();
      });

      const applyButton = slider.closest('.collection-filter-group__body')?.querySelector('.collection-price-range__apply');
      if (applyButton) {
        applyButton.addEventListener('click', (event) => {
          event.preventDefault();
          submitCollectionFiltersForm();
        });
      }

      sliderUi.addEventListener('change', () => {
        syncSliderToForm();
      });
    });
  });

  document.querySelectorAll('[data-collection-view]').forEach((collectionView) => {
    const viewButtons = Array.from(document.querySelectorAll('[data-collection-view-button]'));
    if (!viewButtons.length) return;

    const storageKey = 'limiar-collection-view';
    const availableViews = new Set(['grid', 'list']);

    function setView(view) {
      const nextView = availableViews.has(view) ? view : 'grid';
      collectionView.dataset.collectionView = nextView;

      viewButtons.forEach((button) => {
        const isActive = button.dataset.collectionViewButton === nextView;
        button.classList.toggle('is-active', isActive);
        button.setAttribute('aria-pressed', String(isActive));
      });

      try {
        window.localStorage.setItem(storageKey, nextView);
      } catch (error) {
        // Ignore storage errors.
      }
    }

    let storedView = 'grid';
    try {
      const saved = window.localStorage.getItem(storageKey);
      if (saved && availableViews.has(saved)) {
        storedView = saved;
      }
    } catch (error) {
      // Ignore storage errors.
    }

    setView(storedView);

    viewButtons.forEach((button) => {
      button.addEventListener('click', () => setView(button.dataset.collectionViewButton));
    });
  });

  document.querySelectorAll('[data-product-section]').forEach((section) => {
    const form = section.querySelector('[data-product-form]');
    const variantInput = section.querySelector('[data-variant-id]');
    const optionSelects = Array.from(section.querySelectorAll('[data-product-option]'));
    const addButton = section.querySelector('[data-product-atc]');
    const variantDataNode = section.querySelector('[data-product-variants]');
    const skuItem = section.querySelector('[data-product-sku-item]');
    const skuValue = section.querySelector('[data-product-sku]');
    const mediaItems = Array.from(section.querySelectorAll('[data-product-media]'));
    const thumbButtons = Array.from(section.querySelectorAll('[data-media-target]'));
    const thumbRail = section.querySelector('[data-product-thumbnails]');
    const thumbPrevButton = section.querySelector('[data-product-thumbs-prev]');
    const thumbNextButton = section.querySelector('[data-product-thumbs-next]');
    const prevButton = section.querySelector('[data-product-gallery-prev]');
    const nextButton = section.querySelector('[data-product-gallery-next]');

    if (!form || !variantInput || !variantDataNode) return;

    const personalizationFields = Array.from(section.querySelectorAll('[data-product-personalization] [data-personalization-required="true"]'));
    const personalizationAlert = section.querySelector('[data-personalization-alert]');

    let variants = [];
    let currentMediaIndex = 0;
    let currentVariantAvailable = false;
    let currentVariantPrice = null;
    const stickyBar = section.querySelector('[data-product-sticky-atc]');
    const stickyButton = section.querySelector('[data-product-sticky-button]');
    const stickyPrice = section.querySelector('[data-product-sticky-price]');
    const stickyCompare = section.querySelector('[data-product-sticky-compare]');
    const stickyCompareValue = section.querySelector('[data-product-sticky-compare-value]');
    const stickyCurrentLabel = section.querySelector('[data-product-sticky-current-label]');
    let currentVariantCompareAtPrice = null;

    function updateAddButtonState() {
      if (stickyButton) {
        stickyButton.disabled = !currentVariantAvailable;
        stickyButton.textContent = currentVariantAvailable ? 'Adicionar ao carrinho' : 'Indisponível';
      }

      if (stickyPrice && currentVariantPrice !== null) {
        stickyPrice.textContent = formatMoney(currentVariantPrice);
      }

      const onSale = currentVariantCompareAtPrice !== null && currentVariantCompareAtPrice > currentVariantPrice;
      if (stickyCompare) stickyCompare.hidden = !onSale;
      if (stickyCompareValue) stickyCompareValue.textContent = onSale ? formatMoney(currentVariantCompareAtPrice) : '';
      if (stickyCurrentLabel) stickyCurrentLabel.hidden = !onSale;
    }

    if (stickyBar && addButton && 'IntersectionObserver' in window) {
      const mobileQuery = window.matchMedia('(max-width: 749px)');
      const stickyObserver = new IntersectionObserver(([entry]) => {
        const showSticky = !entry.isIntersecting;
        stickyBar.hidden = !showSticky;
        document.body.classList.toggle('has-sticky-atc', showSticky && mobileQuery.matches);
      });
      stickyObserver.observe(addButton);
    }

    try {
      variants = JSON.parse(variantDataNode.textContent || '[]');
    } catch (error) {
      return;
    }

    function getSelectedOptions() {
      return optionSelects.map((select) => select.value);
    }

    function findVariant() {
      const selectedOptions = getSelectedOptions();
      return variants.find((variant) =>
        variant.options.every((optionValue, index) => optionValue === selectedOptions[index])
      );
    }

    function setActiveMedia(mediaId) {
      const targetId = String(mediaId);
      const nextIndex = mediaItems.findIndex((media) => media.dataset.mediaId === targetId);

      mediaItems.forEach((media, index) => {
        const isActive = media.dataset.mediaId === targetId || (!targetId && index === 0);
        media.classList.toggle('is-active', isActive);
        if (isActive) {
          currentMediaIndex = index;
        }
      });

      thumbButtons.forEach((button) => {
        button.classList.toggle('is-active', button.dataset.mediaTarget === targetId);
      });

      if (nextIndex >= 0) {
        currentMediaIndex = nextIndex;
      }

      const activeThumb = thumbButtons.find((button) => button.dataset.mediaTarget === targetId);
      if (activeThumb && typeof activeThumb.scrollIntoView === 'function') {
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      }
    }

    function goToMedia(direction) {
      if (!mediaItems.length) return;

      const nextIndex = (currentMediaIndex + direction + mediaItems.length) % mediaItems.length;
      const nextMedia = mediaItems[nextIndex];

      if (nextMedia) {
        setActiveMedia(nextMedia.dataset.mediaId);
      }
    }

    function scrollThumbs(direction) {
      if (!thumbRail) return;

      const amount = Math.max(thumbRail.clientWidth * 0.8, 220);
      thumbRail.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    if (thumbRail) {
      let isDraggingThumbs = false;
      let dragStartX = 0;
      let dragStartScrollLeft = 0;
      let dragMoved = false;
      let suppressThumbClick = false;

      thumbRail.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse' || event.button !== 0) return;

        isDraggingThumbs = true;
        dragMoved = false;
        suppressThumbClick = false;
        dragStartX = event.clientX;
        dragStartScrollLeft = thumbRail.scrollLeft;
        thumbRail.classList.add('is-dragging');
        const onPointerMove = (moveEvent) => {
          if (!isDraggingThumbs || moveEvent.pointerType !== 'mouse') return;

          const deltaX = moveEvent.clientX - dragStartX;
          if (Math.abs(deltaX) > 4) {
            dragMoved = true;
          }

          if (dragMoved) {
            thumbRail.scrollLeft = dragStartScrollLeft - deltaX;
          }
        };

        const onPointerUp = (upEvent) => {
          if (!isDraggingThumbs) return;

          isDraggingThumbs = false;
          thumbRail.classList.remove('is-dragging');

          if (dragMoved) {
            suppressThumbClick = true;
            window.setTimeout(() => {
              suppressThumbClick = false;
            }, 0);
          }

          window.removeEventListener('pointermove', onPointerMove);
          window.removeEventListener('pointerup', onPointerUp);
          window.removeEventListener('pointercancel', onPointerUp);
        };

        window.addEventListener('pointermove', onPointerMove);
        window.addEventListener('pointerup', onPointerUp);
        window.addEventListener('pointercancel', onPointerUp);
      }, { passive: true });

      thumbRail.addEventListener('click', (event) => {
        if (!suppressThumbClick) return;

        event.preventDefault();
        event.stopPropagation();
      }, true);
    }

    function syncVariant() {
      const variant = findVariant() || variants[0];
      if (!variant) return;

      variantInput.value = variant.id;
      currentVariantAvailable = Boolean(variant.available);
      currentVariantPrice = variant.price;
      currentVariantCompareAtPrice = variant.compare_at_price || null;

      if (addButton) {
        addButton.disabled = !variant.available;
        addButton.textContent = variant.available ? 'Adicionar ao carrinho' : 'Indisponível';
      }

      if (skuItem && skuValue) {
        const sku = variant.sku || '';
        skuValue.textContent = sku;
        skuItem.hidden = !sku;
        skuItem.classList.toggle('is-empty', !sku);
      }

      const priceRoot = section.querySelector('[data-price-root]');
      if (priceRoot) {
        const currentNode = priceRoot.querySelector('[data-price-current]');
        const compareNode = priceRoot.querySelector('[data-price-compare]');
        const fromNode = priceRoot.querySelector('[data-price-from]');
        const statusNode = priceRoot.querySelector('[data-price-status]');
        const hasCompare = variant.compare_at_price && variant.compare_at_price > variant.price;

        priceRoot.classList.toggle('price--sale', hasCompare);
        priceRoot.classList.toggle('price--sold-out', !variant.available);

        if (!variant.available) {
          if (statusNode) statusNode.hidden = false;
          if (currentNode) currentNode.hidden = true;
          if (compareNode) compareNode.hidden = true;
          if (fromNode) fromNode.hidden = true;
        } else {
          if (statusNode) statusNode.hidden = true;
          if (currentNode) {
            currentNode.hidden = false;
            currentNode.textContent = hasCompare ? `por ${formatMoney(variant.price)}` : formatMoney(variant.price);
          }
          if (compareNode) {
            compareNode.hidden = !hasCompare;
            if (hasCompare) compareNode.innerHTML = `<span class="price__compare-label">De</span> <s>${formatMoney(variant.compare_at_price)}</s>`;
          }
          if (fromNode) fromNode.hidden = true;
        }
      }

      if (variant.featured_media && variant.featured_media.id) {
        setActiveMedia(variant.featured_media.id);
      }

      updateAddButtonState();
    }

    optionSelects.forEach((select) => {
      select.addEventListener('change', syncVariant);
    });

    thumbButtons.forEach((button) => {
      button.addEventListener('click', () => {
        setActiveMedia(button.dataset.mediaTarget);
      });
    });

    if (prevButton) {
      prevButton.addEventListener('click', () => goToMedia(-1));
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => goToMedia(1));
    }

    if (thumbPrevButton) {
      thumbPrevButton.addEventListener('click', () => scrollThumbs(-1));
    }

    if (thumbNextButton) {
      thumbNextButton.addEventListener('click', () => scrollThumbs(1));
    }

    function setPersonalizationAlert(message, isError) {
      if (!personalizationAlert) return;

      if (!message) {
        personalizationAlert.hidden = true;
        personalizationAlert.textContent = '';
        personalizationAlert.classList.remove('is-error');
        return;
      }

      personalizationAlert.textContent = message;
      personalizationAlert.hidden = false;
      personalizationAlert.classList.toggle('is-error', Boolean(isError));
    }

    function clearPersonalizationErrors() {
      personalizationFields.forEach((field) => {
        if (!field) return;
        field.removeAttribute('aria-invalid');
      });
      setPersonalizationAlert('', false);
    }

    function fieldValueIsEmpty(field) {
      if (!field) return true;
      if (field.type === 'checkbox') return !field.checked;
      if (field.tagName === 'SELECT') return String(field.value || '') === '';
      return String(field.value || '').trim() === '';
    }

    function getFirstInvalidPersonalizationField() {
      return personalizationFields.find((field) => fieldValueIsEmpty(field)) || null;
    }

    async function submitProductForm(event) {
      event.preventDefault();
      clearPersonalizationErrors();

      if (!currentVariantAvailable) {
        setPersonalizationAlert('Este produto está indisponível no momento.', true);
        return;
      }

      const firstInvalidField = getFirstInvalidPersonalizationField();
      if (firstInvalidField) {
        const label = firstInvalidField.closest('.field, .product-personalization__field')?.querySelector('label');
        const fieldLabel = label ? label.textContent.trim() : 'Este campo';
        const message = `${fieldLabel} é obrigatório. Preencha os campos de personalização antes de adicionar ao carrinho.`;
        firstInvalidField.setAttribute('aria-invalid', 'true');
        firstInvalidField.focus({ preventScroll: false });
        setPersonalizationAlert(message, true);
        return;
      }

      setPersonalizationAlert('', false);

      const submitter = event.submitter || addButton || null;
      const originalLabel = submitter && submitter.textContent ? submitter.textContent : '';
      if (submitter) {
        submitter.disabled = true;
        submitter.textContent = 'Adicionando...';
      }

      try {
        clearShippingQuote();
        const drawerUpdated = await requestCart('cart/add.js', new FormData(form));
        if (drawerUpdated && cartDrawer) {
          lastCartTrigger = submitter;
          setCartOpen(true);
          return;
        }

        persistCartDrawerState(true);
        window.location.reload();
      } catch (error) {
        setPersonalizationAlert(error.description || 'Não foi possível adicionar o produto agora. Tente novamente.', true);
      } finally {
        if (submitter) {
          submitter.disabled = false;
          submitter.textContent = originalLabel || 'Adicionar ao carrinho';
        }
      }
    }

    if (personalizationFields.length) {
      personalizationFields.forEach((field) => {
        field.addEventListener('input', clearPersonalizationErrors);
        field.addEventListener('change', clearPersonalizationErrors);
      });
    }

    form.addEventListener('submit', submitProductForm);

    syncVariant();
  });
})();
